
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.473 2.672h1.054c.094 0 .141.047.141.14v12.376c0 .093-.047.14-.14.14H8.472c-.094 0-.141-.047-.141-.14V2.812c0-.093.047-.14.14-.14z"}}),_c('path',{attrs:{"d":"M3.094 8.332h11.812c.094 0 .14.047.14.14v1.055c0 .094-.046.141-.14.141H3.094c-.094 0-.14-.047-.14-.14V8.472c0-.094.046-.141.14-.141z"}})])
          )
        }
      }
    